import React from "react";
import styles from "./SelectTermItem.module.scss";
import { getDefaultImage } from "../../utils/GeneralUtils";
import { SonicTermData } from "../classes/SonicTerm";

type Props = {
  type: "checkbox" | "select";
  terms?: Array<SonicTermData>;
  term_option: SonicTermData;
  checkHandler?: (checked: boolean, value: SonicTermData) => void;
  selectHandler?: (value: SonicTermData) => void;
  checked?: boolean;
  disabled?: boolean;
};
const SelectTermItem: React.FC<Props> = ({
  type,
  terms,
  term_option,
  checkHandler,
  selectHandler,
  checked,
  disabled = false,
}) => {
  return (
    <div>
      {type === "checkbox" && checkHandler ? (
        <>
          <input
            type="checkbox"
            id={term_option.id}
            name={term_option.taxonomy.slug}
            className={styles[`c-select-term__${type}`]}
            onChange={(e) => checkHandler(e.target.checked, term_option)}
            checked={checked}
            disabled={disabled}
          />
          <label
            htmlFor={term_option.id}
            className={`${styles["c-select-term__label"]} ${styles[type]}`}
          >
            <div className={styles["c-select-term__imgbox"]}>
              <img
                src={
                  term_option.img?.large?.url
                    ? term_option.img.large.url
                    : getDefaultImage()
                }
                alt="SELeCTデフォルト画像"
              />
            </div>
            <div className={styles["c-select-term__name"]}>
              {term_option.name}
            </div>
          </label>
        </>
      ) : null}

      {type === "select" && selectHandler ? (
        <>
          <label
            className={
              terms?.some((t) => t.id === term_option.id)
                ? `${styles["c-select-term__label"]} ${styles["selected"]}`
                : `${styles["c-select-term__label"]} ${styles[type]}`
            }
            onClick={() => selectHandler(term_option)}
          >
            <div className={styles["c-select-term__imgbox"]}>
              <img
                src={
                  term_option.img?.large?.url
                    ? term_option.img.large.url
                    : getDefaultImage()
                }
                alt="SELeCTデフォルト画像"
              />
            </div>
            <div className={styles["c-select-term__name"]}>
              {term_option.name}
            </div>
          </label>
        </>
      ) : null}
    </div>
  );
};

export default SelectTermItem;
